export { LandingHeroV2, type LandingHeroV2Props } from './landing-hero-v2'
